//Creating redux slices
import { createSlice } from "@reduxjs/toolkit";

/**
 * Redux slice for handling authentication state.
 *
 * @property {boolean} value - Whether the user is logged in.
 * @property {string|null} role - Role of the user (e.g., "admin", "cashier").
 */
export const authSlice = createSlice({
  name: "verifyLogin",

  // Initial state of the slice
  initialState: {
    value: false,
    role: null,
  },

   // Reducers define actions that can update the state
  reducers: {
    login: (state, action) => {
      state.value = true;
      state.role = action.payload.role
    },
    logout: (state) => {
      window.location.reload();
      // Clear localStorage items
      localStorage.clear();
      sessionStorage.clear();
      // Clear Redux state
      state.value = false;
      state.role = null;
    },
  },
});
export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
